import React from 'react';
import PropTypes from 'prop-types';
import StringUtils from '../utils/string';
import BrowserUtils from '../utils/browser';

class MessageCreator extends React.Component {
  constructor (props) {
    super(props);
    this.state = { message: '' };
    this._isDesktop = BrowserUtils.isDesktop();
  }

  componentDidMount() {
    this.focusTextArea();
    this.resizeMessageList();
    $(window).on('resize.messageCreator', this.resizeTextArea.bind(this, { message: '' }));
  }

  componentWillUnmount() {
    $(window).off('resize.messageCreator');
  }

  componentDidUpdate (prevProps, prevState) {
    this.focusTextArea();
    this.resizeTextArea(prevState);
    if (prevProps.activeConversation !== this.props.activeConversation) {
      this.clearMessage();
      this.resizeMessageList();
    }
  }

  clearMessage() {
    if (this.state.message.length) {
      this.setState({ message: '' });
    }
  }

  handleSubmit (e) {
    e.preventDefault();
    this.submitForm();
  }

  submitForm() {
    const message = { body: this.state.message };
    this.props.persistMessage(message, this.props.url, { id: this.props.activeConversation }).then(this.clearMessage.bind(this));
  }

  errors() {
    const errors = this.props.errors;

    if (errors) {
      return (
        <div className="pull-left text-danger">{errors.join(', ')}</div>
      );
    }
  }

  handleKeyDown (e) {
    if (((e.which || e.keyCode) === 13) && (e.ctrlKey || e.metaKey)) {
      if (!this.disableSubmit()) {
        this.submitForm();
      }
      e.preventDefault();
    }
  }

  handleChange (e) {
    this.setState({ message: e.target.value });
  }

  disableSubmit() {
    return this.props.disabled || StringUtils.trim(this.state.message).length === 0;
  }

  resizeMessageList() {
    const messageBoxHeight = $(this._messageBox).outerHeight();
    if (messageBoxHeight !== this.props.height) {
      this.props.setHeight(messageBoxHeight);
    }
  }

  resizeTextArea(prevState) {
    if (prevState && (prevState.message.length !== this.state.message.length) && this._textArea) {
      $(this._textArea).height('').innerHeight(this._textArea.scrollHeight);
      this.resizeMessageList();
    }
  }

  focusTextArea() {
    if (this._textArea && this._isDesktop) {
      $(this._textArea).focus();
    }
  }

  render() {
    const columnClass = this.props.conversationDetailsVisible ? 'col-md-6' : 'col-md-9';

    return (
      <section className={`${columnClass} col-md-offset-3 message-box`}
        ref={mb => { this._messageBox = mb; }}>
        <div className="message-box-contents">
          {
            !this.props.activeConversation
              ? null
              : <form
                  className="new_conversation_message"
                  id="new_conversation_message"
                  action={this.props.url}
                  acceptCharset="UTF-8"
                  method="post"
                  onSubmit={this.handleSubmit.bind(this)}>
                    <input name="utf8" type="hidden" value="✓"/>
                    <div className="conversation-message clearfix">
                      <div className="form-container">
                        <textarea
                          className="t3 form-control autosize"
                          placeholder="Write a message"
                          rows="1"
                          style={{ height: '48px' }}
                          draggable="false"
                          name="conversation_message[body]"
                          value={this.state.message}
                          onKeyDown={this.handleKeyDown.bind(this)}
                          onChange={this.handleChange.bind(this)}
                          ref={ta => { this._textArea = ta; }}></textarea>
                        {this.errors()}
                      </div>
                      <div className="submit-btn message-creator-submit">
                        <input
                          type="submit"
                          name="commit"
                          value="Send"
                          className="btn-main"
                          data-disable-with="Send"
                          disabled={this.disableSubmit()}/>
                      </div>
                    </div>
                </form>
          }
        </div>
      </section>
    );
  }
}

MessageCreator.propTypes = {
  activeConversation: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  errors: PropTypes.array,
  persistMessage: PropTypes.func.isRequired,
  setHeight: PropTypes.func.isRequired,
  height: PropTypes.number.isRequired
};

export default MessageCreator;
